const faqToggle = () => {
  $('.p-faq__item-header').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).next('.p-faq__item-body').slideToggle();
  });
}

export default faqToggle;
